var map = {
	"./airdrop.vue": 55342,
	"./bot.vue": 15541,
	"./botcode.vue": 99593,
	"./center.vue": 70138,
	"./daily.vue": 4720,
	"./face.vue": 11427,
	"./facescan.vue": 81684,
	"./friends.vue": 54757,
	"./gifts.vue": 28043,
	"./human.vue": 43541,
	"./index.vue": 41194,
	"./lucky.vue": 22451,
	"./pass.vue": 51309,
	"./rank.vue": 62558,
	"./ranks.vue": 1849,
	"./rewards.vue": 47535,
	"./ris.vue": 39485,
	"./slotMachine.vue": 80383,
	"./turn.vue": 33853,
	"./upgrade.vue": 5262,
	"./walletDetail.vue": 32454,
	"./withdraw.vue": 30963
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68239;